//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory4Lang', {
//        templateUrl: 'views/components/views/textileModelCategory4Lang/textileModelCategory4Lang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'textileModelCategory4LangService', function ($stateParams, stateService, textileModelCategory4LangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory4Keyno = $stateParams.textilemodelcategory4_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory4Languages() {
//                vm.model.inputListLanguages = await textileModelCategory4LangService.listTextileModelCategory4Languages({ textilemodelcategory4_keyno: textileModelCategory4Keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory4LangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory4Languages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
